import type { ComponentProps } from "react"
import MediaQuery from "react-responsive"

const MOBILE_BREAKPOINT = 730

type MediaQueryProps = ComponentProps<typeof MediaQuery>

export const Desktop = (props: MediaQueryProps) => <MediaQuery {...props} minWidth={MOBILE_BREAKPOINT + 1} />
export const Mobile = (props: MediaQueryProps) => <MediaQuery {...props} maxWidth={MOBILE_BREAKPOINT} />
